import React from "react";
import { motion } from "framer-motion";

const containerVariants = {
  hidden: { opacity: 0 },
  visible: {
    opacity: 1,
    transition: {
      delayChildren: 0.3,
      staggerChildren: 0.08,
    },
  },
};

const itemVariants = {
  hidden: (direction) => ({
    x: direction === "left" ? -100 : 100,
    opacity: 0,
  }),
  visible: {
    x: 0,
    opacity: 1,
    transition: {
      duration: 0.6,
      ease: [0.25, 0.46, 0.45, 0.94],
    },
  },
};

const AnimatedGrid = ({
  children,
  className = "",
  direction = "left",
  columns = "repeat(auto-fit, minmax(300px, 1fr))",
  gap = "20px",
  style = {},
}) => {
  return (
    <motion.div
      variants={containerVariants}
      initial="hidden"
      whileInView="visible"
      viewport={{ once: true, amount: 0.2 }}
      style={{
        display: "grid",
        gridTemplateColumns: columns,
        gap: gap,
        ...style,
      }}
      className={className}
    >
      {React.Children.map(children, (child, index) => (
        <motion.div key={index} custom={direction} variants={itemVariants}>
          {child}
        </motion.div>
      ))}
    </motion.div>
  );
};

export default AnimatedGrid;
